<template>
  <el-dialog
    class="custom-dialog custom-dialog-login custom-dialog-login-english"
    ref="dialog-login"
    :visible.sync="showLoginDialogFlag"
    :append-to-body="true"
    :modal-append-to-body="false"
    :close-on-press-escape="true"
    :withHeader="false"
    :destroy-on-close="true"
    :show-close="true"
    :close-on-click-modal="true"
    :wrapperClosable="true"
    :width="drawerWidth"
    :top="dialogTop"
    @close="close"
  >
    <!-- Header with logo and title -->
    <div class="login-header">
      <div class="header-content">
        <div class="logo-container">
          <div class="title-container">
            <h1 class="welcome-text" style="font-size: 3rem; color: #242424; font-weight: bold;">Welcome</h1>
            <h2 class="app-name" style="display: flex; align-items: center; gap: 0.5rem;">
              <img src="@/assets/icon-login-logo.png" class="header-logo" style="width: 2rem; height: 2rem;"/>
              <span style="font-size: 1.5rem; font-weight: bold;">MaliWriter</span>
            </h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Login form -->
    <div class="login-form-container">
      <el-form class="login-form" label-position="left" :hide-required-asterisk="true">
        <div class="form-group">
          <div class="input-container">
            <i class="el-icon-message input-icon"></i>
            <el-input
              v-model="email"
              placeholder="Enter your email address"
              class="custom-input-text email-input"
              clearable
            />
            <el-button
              type="primary"
              size="small"
              class="verification-button"
              @click="onSendVerificationCode"
              :loading="sendingCode"
              :disabled="!email || countdown > 0"
            >
              {{ countdown > 0 ? `${countdown}s` : 'Get Code' }}
            </el-button>
          </div>
        </div>

        <div class="form-group">
          <div class="input-container">
            <i class="el-icon-key input-icon"></i>
            <el-input
              v-model="verificationCode"
              placeholder="Enter verification code"
              class="custom-input-text"
              clearable
            />
          </div>
        </div>

        <div class="form-group">
          <el-checkbox v-model="rememberAccount" class="remember-checkbox">
            Remember account
          </el-checkbox>
        </div>

        <div class="form-group">
          <el-button
            type="primary"
            class="login-button w-full"
            @click="onLogin"
            :loading="loading"
          >
            Login/Register
          </el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations} from 'vuex'
import * as userApi from '@/api/user'

export default {
  name: 'LoginDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      email: '',
      password: '',
      verificationCode: '',
      rememberAccount: false,
      loading: false,
      sendingCode: false,
      countdown: 0
    }
  },
  computed: {
    ...mapState(['user', 'story', 'showLoginDialogFlag', 'urlquery']),
    drawerWidth() {
      return window.innerWidth <= 768 ? '90%' : '21%';
    },
    dialogTop() {
      return window.innerWidth <= 768 ? "20vh" : '10vh';
    }
  },
  methods: {
    ...mapMutations(['setStory', 'setUser', 'setToken', 'setShowLoginDialogFlag', 'setShowVideoFlag', 'setIsAuthenticated']),
    close() {
      this.setShowLoginDialogFlag(false);
    },

    async onSendVerificationCode() {
      if (!this.email) {
        this.$message.error('Please enter your email address first');
        return;
      }
      
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.$message.error('Please enter a valid email address');
        return;
      }

      this.sendingCode = true;
      
      try {
        await userApi.sendVerificationCode({
          email: this.email
        })
        this.$message.success('Verification code sent successfully');
        this.startCountdown();
      } catch (error) {
        this.$message.error('Failed to send verification code. Please try again.');
        console.error('Error sending verification code:', error);
      } finally {
        this.sendingCode = false;
      }
    },
    startCountdown() {
      this.countdown = 60;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    async onLogin() {
      if (!this.email || !this.verificationCode) {
        this.$message.error('Please fill in all fields');
        return;
      }

      this.loading = true

      try {
        const res = await userApi.loginByEmail({
          password: '123456',
          username: this.email,
          verifyCode: this.verificationCode
        })
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
          return
        }

        this.account = res.data.data
        console.log('handleLogin', this.account);
        localStorage.setItem('lyToken', this.account.token)
        localStorage.setItem('lyAccount', JSON.stringify(this.account))

        this.$store.commit('setToken', this.account.token)
        this.$store.commit('setUser', this.account)

        this.$store.commit('setIsAuthenticated', this.account.token != '')
        this.$router.push('/home')
        // 调用 this.handleNewerGift();
        this.$parent.handleNewerGift();
        this.setShowLoginDialogFlag(false);
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
@media (min-width: 768px) {
  .custom-dialog-login .el-dialog {
    min-width: 350px !important;
  }
}
.el-input--small .el-input__inner {
  height: 40px !important;
  line-height: 40px !important;
}
.custom-dialog-login-english.custom-dialog .el-dialog__body {
  padding: 0.5rem 1.5rem 1rem 1.5rem !important;
}
</style>

<style scoped lang="scss">
.custom-dialog-login {
  .el-dialog {
    border-radius: 12px;
    overflow: hidden;
  }
}

.login-header {
  .header-content {
    .logo-container {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      .logo-icon {
        width: 60px;
        height: 60px;
        background: linear-gradient(135deg, #366EF4, #0052D9);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        
        i {
          font-size: 28px;
          color: white;
        }
      }
      
      .title-container {
        .welcome-text {
          font-size: 2rem;
          font-weight: bold;
          color: rgba(41, 40, 43, 0.8);
          margin: 0 0 0.5rem 0;
        }
        
        .app-name {
          font-size: 1.5rem;
          font-weight: 600;
          color: #366EF4;
          margin: 0 0 0.5rem 0;
        }
        
        .slogan {
          color: rgba(41, 40, 43, 0.6);
          font-size: 16px;
          letter-spacing: 2px;
        }
      }
    }
  }
}

.login-form-container {
  .login-form {
    color: #ffffff;
    padding: 1rem 0;
    
    .form-group {
      margin-bottom: 1rem;
      
      .input-container {
        position: relative;
        
        .input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(41, 40, 43, 0.6);
          z-index: 1;
        }
        
        .custom-input-text {
          /deep/ .el-input__inner {
            padding-left: 40px;
            height: 48px;
            border-radius: 8px;
            border: 1px solid rgba(41, 40, 43, 0.2);
            background: rgba(255, 255, 255, 0.9);
            
            &:focus {
              border-color: #366EF4;
              box-shadow: 0 0 0 2px rgba(54, 110, 244, 0.1);
            }
          }
          
          &.email-input {
            /deep/ .el-input__inner {
              padding-right: 100px;
            }
          }
        }
        
        .verification-button {
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
          height: 32px;
          padding: 0 12px;
          font-size: 12px;
          border-radius: 6px;
          background: linear-gradient(135deg, #366EF4, #0052D9);
          border: none;
          color: white;
          z-index: 2;
          
          &:hover {
            background: linear-gradient(135deg, #0052D9, #366EF4);
            transform: translateY(-50%) translateY(-1px);
            box-shadow: 0 2px 8px rgba(54, 110, 244, 0.3);
          }
          
          &:active {
            transform: translateY(-50%);
          }
          
          &:disabled {
            background: #c0c4cc;
            cursor: not-allowed;
            transform: translateY(-50%);
            box-shadow: none;
          }
        }
      }
      
      .remember-checkbox {
        color: rgba(41, 40, 43, 0.6);
        font-size: 14px;
        
        /deep/ .el-checkbox__label {
          color: rgba(41, 40, 43, 0.6);
        }
      }
      
      .login-button {
        width: 100%;
        height: 48px;
        border-radius: 8px !important;
        background: linear-gradient(135deg, #366EF4, #0052D9);
        border: none;
        font-weight: 600;
        font-size: 16px;
        
        &:hover {
          background: linear-gradient(135deg, #0052D9, #366EF4);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(54, 110, 244, 0.3);
        }
        
        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

/deep/ .custom-dialog .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.01) !important;
}

/deep/ .custom-dialog .el-dialog {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.w-full {
  width: 100% !important;
}

.pointer {
  cursor: pointer;
}

.d-flex {
  display: flex;
}

.flex-between {
  justify-content: space-between;
}

.mt {
  margin-top: 1rem !important;
}

.mb {
  margin-bottom: 1rem !important;
}
</style>